'use es6';

import hubHttp from 'hub-http-rxjs/clients/apiClient';
import { map } from 'rxjs/operators/map';
import { USER_ATTRIBUTES_TO_FETCH } from '../constants/tour';
const attributesEndpoint = 'users/v1/app/attributes';

const parseAttributesResponseIntoObject = result => {
  return result.attributes.reduce((attrs, attr) => Object.assign({}, attrs, {
    [attr.key]: attr.value
  }), {});
};

export default {
  getAttributes(keys = USER_ATTRIBUTES_TO_FETCH) {
    return hubHttp.get(attributesEndpoint, {
      query: {
        keys
      }
    }).pipe(map(parseAttributesResponseIntoObject));
  },

  setAttribute(attribute, value) {
    const body = {
      data: {
        key: attribute,
        value
      }
    };
    return hubHttp.post(attributesEndpoint, body);
  }

};